module.exports = __webpack_public_path__ + "img/paper.25e132ba.svg";